import { render, staticRenderFns } from "./FormBoxSelect.vue?vue&type=template&id=f21b923e&scoped=true&"
import script from "./FormBoxSelect.vue?vue&type=script&lang=js&"
export * from "./FormBoxSelect.vue?vue&type=script&lang=js&"
import style0 from "./FormBoxSelect.vue?vue&type=style&index=0&id=f21b923e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f21b923e",
  null
  
)

export default component.exports